import AsyncStorage from '@react-native-async-storage/async-storage';
import * as SecureStore from 'expo-secure-store';
import * as Localization from 'expo-localization';
import { Platform } from 'react-native';
import { v4 as uuidv4 } from 'uuid';
import * as Constants from './Constants';

// Storage functions that are used by both Commons and ServerOperations
export const getFromAS = async key => {
  try {
    if (Platform.OS === 'web' || true) {
      return await AsyncStorage.getItem(key);
    }
    return await SecureStore.getItemAsync(key);
  } catch (error) {
    console.log(error);
  }
};

export const saveToAS = async (key, value) => {
  try {
    if (Platform.OS === 'web' || true) {
      await AsyncStorage.setItem(key, value);
      return;
    }
    await SecureStore.setItemAsync(key, value);
  } catch (error) {
    console.log(error);
  }
};

export const multiSaveToAS = async (pairs) => {
  try {
    await AsyncStorage.multiSet(pairs);
  } catch (error) {
    console.log(error);
  }
};

export const removeFromAS = async (key) => {
  try {
    return await AsyncStorage.removeItem(key);
  } catch (error) {
    console.log(error);
  }
};

// Device ID functions
export const getDeviceID = async () => {
  if (Platform.OS === 'web' || true) {
    let fetchUUID = await AsyncStorage.getItem('secure_deviceid');
    if (fetchUUID) {
      return fetchUUID.replace(/"/g, "");
    }
    let uuid = uuidv4().replace(/"/g, "");
    await AsyncStorage.setItem('secure_deviceid', JSON.stringify(uuid));
    return uuid;
  } else {
    let fetchUUID = await SecureStore.getItemAsync('secure_deviceid');
    if (fetchUUID) {
      return fetchUUID.replace(/"/g, "");
    }
    let uuid = uuidv4().replace(/"/g, "");
    await SecureStore.setItemAsync('secure_deviceid', JSON.stringify(uuid));
    return uuid;
  }
};

// Language function
export const language = async () => {
  const languageFromStorage = await getFromAS(Constants.language);
  const locales = Localization.getLocales();
  let locale =
    (locales && locales.length > 0 && locales[0].languageCode) || "en";

  if (!locale.startsWith("ar") && !locale.startsWith("en")) {
    locale = "en";
  }
  locale = languageFromStorage == null ? locale : languageFromStorage;
  return locale;
};

// User object function
export const getUserObject = async () => {
  const keys = [
    Constants.email,
    Constants.username,
    Constants.password,
    Constants.firstName,
    Constants.lastName,
    Constants.birthdate,
    Constants.gender,
    Constants.mobile,
    Constants.location,
    Constants.maritalStatus,
    Constants.numOfChildren,
    Constants.address,
    Constants.loggedIn,
    Constants.isAdmin,
    Constants.addressNote,
  ];

  const values = [];
  await AsyncStorage.multiGet(keys, (err, stores) => {
    stores.map((result, i, store) => {
      const value = store[i][1];
      values.push(value);
    });
  });

  const user = {};
  user.EMAIL = values[0];
  user.USERNAME = values[1];
  user.PASSWORD = values[2];
  user.FIRSTNAME = values[3];
  user.LASTNAME = values[4];
  user.BIRTHDATE = values[5];
  user.GENDER = values[6];
  user.MOBILE = values[7];
  user.LOCATION = values[8];
  user.MARITAL_STATUS = values[9];
  user.NUM_OF_CHILDREN = values[10];
  user.ADDRESS = values[11];
  user.LOGGEDIN = values[12];
  user.ISADMIN = values[13];
  user.ADDRESS_NOTE = values[14];

  const customerUSERNAME = await getFromAS("customerUSERNAME");
  const customerMOBILE = await getFromAS("customerMOBILE");
  if (
    customerUSERNAME != null &&
    customerUSERNAME != undefined &&
    customerUSERNAME != ""
  ) {
    user.USERNAME = customerUSERNAME;
    user.MOBILE = customerMOBILE;
  }

  if (user.USERNAME === "931386753963673") {
    user.MOBILE = "0797580004";
    user.ADDRESS = "Hidhab street no 6 Abdoun.. behind American embassy";
    user.LOCATION = "";
  }
  if (user.USERNAME === "519857305549339") {
    user.mobile = "0777707747";
  }
  if (user.USERNAME == "samarh") {
    user.LOCATION = "32.02800750732422,35.8565673828125";
  }
  return user;
};

// Push notifications token function (if needed)
export const getPushNotificationsToken = async () => {
  // This function might need to be implemented based on your notification setup
  return await getFromAS(Constants.PUSH_TOKEN);
};